"use client";

import React, { useState, useEffect } from "react";
import { Signal, Wifi, Battery } from "lucide-react";

export const StatusBar = React.memo(({ onClick }: { onClick?: () => void }) => {
  const [currentTime, setCurrentTime] = useState("");
  const [spotifyData, setSpotifyData] = useState<{ isPlaying: boolean; title?: string; artist?: string } | null>(null);

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setCurrentTime(
        now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      );
    };
    updateTime();
    const interval = setInterval(updateTime, 10000); 

    const fetchSpotify = async () => {
      try {
        const res = await fetch("/api/v1/status");
        const data = await res.json();
        setSpotifyData(data);
      } catch (e) {}
    };
    fetchSpotify();
    const spotifyInterval = setInterval(fetchSpotify, 30000);

    return () => {
      clearInterval(interval);
      clearInterval(spotifyInterval);
    };
  }, []);

  return (
    <div
      className="absolute top-0 left-0 right-0 h-14 flex justify-between items-center px-8 z-50 text-[14px] font-bold tracking-tight cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-center gap-3 w-40">
        <span>{currentTime}</span>
        {spotifyData?.isPlaying && (
          <div className="flex items-center gap-2 bg-black/40 backdrop-blur-md px-2 py-0.5 rounded-full border border-white/5 animate-in fade-in slide-in-from-left-4">
            <div className="flex gap-[1px] items-end h-2">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="w-[1.5px] bg-green-500 rounded-full animate-music-bar"
                  style={{ animationDelay: `${i * 0.1}s` }}
                />
              ))}
            </div>
            <span className="truncate max-w-[80px] text-[10px] text-green-500">
              {spotifyData.title}
            </span>
          </div>
        )}
      </div>
      <div className="flex gap-2.5 items-center">
        <Signal className="w-4.5 h-4.5" />
        <Wifi className="w-4.5 h-4.5" />
        <Battery className="w-6 h-6 border-white/20" />
      </div>
    </div>
  );
});

StatusBar.displayName = "StatusBar";
